module.exports = "/_next/static/images/454f3d58ed567f94c0fb443cfebacc14-hero-lg@1x.jpg";